import type { FC } from 'react';

import { Tag } from '@crehana/compass.ui/v3/tag';
import { BasicTooltip, TooltipProvider } from '@crehana/compass.ui/v3/tooltip';

import useTeamCoursesTranslation from '../../hooks/useTeamCoursesTranslation/useTeamCoursesTranslation';

export type TTrackStatusTagsProps = {
  isNewCoursesFeatureEnabled: boolean;
  contentUpdatedAt: string | null;
  isClosed: boolean;
};

export const TrackStatusTags: FC<TTrackStatusTagsProps> = ({
  isNewCoursesFeatureEnabled,
  contentUpdatedAt,
  isClosed,
}) => {
  const { t } = useTeamCoursesTranslation();

  return (
    <>
      <p className="tw-cds-font-label-01 tw-uppercase tw-text-neutral-light-700 dark:tw-text-neutral-dark-400">
        {t('LEARNING_PATHS_LEFT_SIDE_TITLE')}
      </p>
      {isNewCoursesFeatureEnabled && contentUpdatedAt && (
        <Tag variant="pending" className="tw-w-fit">
          {t('LEARN_TEAM_HEADER_DETAIL_UPDATED')}
        </Tag>
      )}
      {isNewCoursesFeatureEnabled && (
        <TooltipProvider>
          <BasicTooltip
            content={t(
              isClosed
                ? 'LEARN_TEAM_HEADER_DETAIL_CLOSED_TOOLTIP'
                : 'LEARN_TEAM_HEADER_DETAIL_OPEN_TOOLTIP',
            )}
            side="right"
          >
            <Tag variant={isClosed ? 'pending' : 'info'} className="tw-w-fit">
              {t(
                isClosed
                  ? 'LEARN_TEAM_HEADER_DETAIL_CLOSED'
                  : 'LEARN_TEAM_HEADER_DETAIL_OPEN',
              )}
            </Tag>
          </BasicTooltip>
        </TooltipProvider>
      )}
    </>
  );
};
